<template>
  <div class="album-detail maxW" style="margin-top:7%">
    <div class="album-nav-link">
      <router-link to="/home/albumList">{{ $t('homepage.album') }}</router-link>
      <strong>
        <i>></i>{{ albumData.name }}
      </strong>
    </div>
    <div class="album-window clear">
      <div class="album-window-l">
        <img :src="BASE_URL + albumData.picture" />
      </div>
      <div class="album-window-r fr">
        <h2 class="albumb-w-h2">{{ albumData.name }}</h2>
        <div class="keyword-tips">
          <el-tag
            v-for="item in albumData.keyword_arr"
            :key="item"
          >{{ item }}</el-tag>
        </div>
        <ul class="clear">
          <li class="albumb-class fl">
            <div>
              <span class="video-count">{{ albumData.videocount }}</span>
              <span class="a-tit">{{ $t('homepage.course') }}</span>
            </div>
          </li>
          <li class="albumb-study-count clear">
            <div>
              <span class="user-count">{{ albumData.usercount }}</span>
              <span class="a-tit">{{ $t('homepage.learner') }}</span>
            </div>
          </li>
          <li class="albumb-study-count clear">
            <el-button
              class="share-btn fr"
              @click="share"
            ><img src="../../../../assets/images/share_icon.png">{{
              $t('homepage.shareLink')
            }}</el-button>
          </li>
        </ul>
      </div>
    </div>
    <div class="album-introduction">
      <div class="album-nav-tabs">
        <span
          :class="[albumTab == 1 ? 'nav-tab is-active' : 'nav-tab']"
          :style="$i18n.locale === 'en-us' ? 'width: 200px' : 'width: 160px'"
          @click="taggleTabs(1)"
        >{{
            $t('homepage.catalog')
          }}</span>
        <span
          :class="[albumTab == 2 ? 'nav-tab is-active' : 'nav-tab']"
          :style="$i18n.locale === 'en-us' ? 'width: 200px' : 'width: 160px'"
          @click="taggleTabs(2)"
        >{{
            $t('homepage.introduction')
          }}</span>
      </div>
      <div class="tab-panes">
        <div
          v-show="albumTab == 1"
          class="tab-pane"
        >
          <ul class="album-ul">
            <li
              class="album-ls"
              v-for="(item, index) of albumListData"
              :key="index"
            >
              <div class="album-tit clear" style="display:flex">
                <span class="tit-num">{{ getChapter(index + 1) }}</span>
                <div class="album-tit-name">
                  <span>{{ item.album_lname }}</span>
                </div>
              </div>
              <ul>
                <li
                  class="album-ls2 clear"
                  v-for="(item1, index1) of item.child"
                  :key="index1"
                >
                  <div
                    class="section-title"
                    @click="foldSection(item1,index1)"
                  >{{item1.album_lname }}</div>
                  <div v-show="item1.status">
                    <div
                      class="video-content"
                      v-for="(video) of item1.video"
                      :key="video.id"
                    >
                      <div class="video-title">{{video.name}}</div>
                      <template v-if="video.origin == 0">
                        <i class="video_type">{{ $t('homepage.video') }}</i>
                        <div class="album_btns">
                          <el-button
                            type="primary"
                            @click="downloadFile(0, video.is_download, video.res_id, video.source_url)"
                          >
                            {{ $t('global.download') }}</el-button>
                          <el-button
                            type="primary"
                            @click="checkResource(0, video.res_id, video.id)"
                          >
                            {{ $t('global.check') }}</el-button>
                        </div>
                      </template>
                      <template v-else-if="video.origin == 1">
                        <i class="video_type">{{ $t('homepage.test') }}</i>
                        <div class="album_btns">
                          <el-button
                            type="primary"
                            @click="downloadFile(1, 1, video.res_id, video.source_url)"
                          >
                            {{ $t('global.download') }}</el-button>
                          <el-button
                            type="primary"
                            @click="checkResource(1, video.res_id, video.id)"
                          >
                            {{ $t('global.check') }}</el-button>
                        </div>
                      </template>
                      <template v-else>
                        <i class="video_type">{{ $t('homepage.resource') }}</i>
                        <div class="album_btns">
                          <el-button
                            type="primary"
                            @click="downloadFile(2, video.is_download, video.res_id, video.source_url)"
                          >
                            {{ $t('global.download') }}</el-button>
                          <el-button
                            type="primary"
                            @click="checkResource(2, video.res_id, video.id)"
                          >
                            {{ $t('global.check') }}</el-button>
                        </div>
                      </template>
                    </div>
                  </div>

                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div
          v-show="albumTab == 2"
          class="tab-pane"
        >
          <div class="albumIntroduction clear">
            <a
              class="avatar-path"
              href="javascript:;"
              rel="noopener noreferrer"
            >
              <!-- :src="BASE_URL + albumIntroductData.avatar_path" -->
              <!-- <img src="../../../assets/images/morentouxiang.png" /> -->
              <img :src="create_avatar_path">
            </a>
            <div class="albumIntroduction-r">
              <div class="about-teacher clear">
                <div class="teacher-info fl">
                  <a
                    href="javascript:;"
                    rel="noopener noreferrer"
                  >{{ albumData.custom_speaker }}</a>
                </div>
              </div>
              <!-- <ul class="other-infos clear">
								<li class="fl'">
									<div>
										<i id="video_num">{{ albumIntroductData.video_num }}</i>
										<span>{{$t('homepage.course')}}</span>
									</div>
								</li>
								<li class="fl'">
									<div>
										<i id="video_click">{{ albumIntroductData.video_click }}</i>
										<span>{{$t('homepage.playCounts')}}</span>
									</div>
								</li>
							</ul> -->
            </div>
          </div>
          <div class="album-profile clear">
            <span>{{ $t('homepage.introduction') }}:</span>
            <div
              class="content"
              v-html="profile == '' ? $t('global.noData') : profile"
            ></div>
          </div>
        </div>

      </div>
    </div>
    <!-- 发私信弹窗： -->
    <!-- <chat ref="child"></chat> -->

    <el-dialog
      :title="$t('homepage.shareLink')"
      class="share_dialog"
      :visible.sync="showShare"
      width="550px"
    >
      <p class="share_text">{{ $t('global.copyUrlmessage') }}</p>
      <p class="share_text">
        <el-radio-group
          v-model="changeCopy"
          @change="getCopyVal"
        >
          <el-radio :label="1">{{ $t('global.webUrl') }}</el-radio>
          <el-radio :label="2">{{ $t('global.H5Url') }}</el-radio>
        </el-radio-group>
      </p>
      <p class="share_link">{{ $t('global.linkUrl') }}：<a
          style="color:deepskyblue"
          href="#"
        >{{ shareLink }}</a> </p>
      <el-button
        class="copy_btn"
        type="primary"
        @click="copyShareLink"
      >{{ $t('global.copy') }}</el-button>
    </el-dialog>
  </div>
</template>
<script>
// import vueEmoji from "@/components/common/emoji";
// import chat from "@/components/common/chat";
export default {
  data() {
    return {
      user_login_id: this.$g.user_id,
      albumId: this.$route.query.id,
      albumData: {},
      is_fav: 0,
      albumTab: 1,
      albumListData: [],
      albumIntroductData: {},
      profile: "",
      create_id: null,
      is_relation: 0,
      // pdf
      outline_url: "",
      outline_path: "",
      outline_name: "",
      teaching_url: "",
      teaching_path: "",
      teaching_name: "",
      showShare: false, //显示分享弹窗
      changeCopy: 1, // 选择复制
      shareLink: "", // 分享地址
      videoSign: "",
      create_avatar_path: "",
    };
  },
  created() {
    this.getAlbum();
    this.getAlbumList();
  },
  computed: {
    isTencentCloud() {
      return sessionStorage.getItem("tencentCloud") ? true : false;
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem("SharePage");
  },
  methods: {
    foldSection(item1, index1) {
      item1.status = !item1.status;
    },
    // 多语言，获取章节序列号
    getChapter(index) {
      return this.$t("homepage.chapter").replace(/1/g, index);
    },
    downloadoutline() {
      window.location.href =
        this.BASE_URL +
        "/index/album/albumdownload?path=" +
        this.outline_path +
        "&name=" +
        this.outline_name;
    },
    downloadteaching() {
      window.location.href =
        this.BASE_URL +
        "/index/album/albumdownload?path=" +
        this.teaching_path +
        "&name=" +
        this.teaching_name;
    },

    // 获取专辑数据：
    getAlbum() {
      let success = (data) => {
        this.videoSign = data.data.album_sign;
        this.albumData = data.data;
        this.is_fav = data.data.is_fav;
        this.profile = data.data.profile;

        this.outline_url = data.data.outline_url;
        this.outline_path = data.data.outline_path;
        this.outline_name = data.data.outline_name;

        this.teaching_url = data.data.teaching_url;
        this.teaching_path = data.data.teaching_path;
        this.teaching_name = data.data.teaching_name;

        this.albumId = data.data.id;
        sessionStorage.setItem(
          "sharePath",
          this.BASE_URL + "/home/albumDetail?id=" + data.data.id
        );
        this.create_id = data.data.create_id;
      };
      this.$ajax({
        url: "api/album/getalbum_info",
        method: "get",
        params: {
          album_sign: sessionStorage.getItem("album_sign"),
        },
        func: {
          success: success,
        },
      });
    },
    getCopyVal(val) {
      this.getShareLink();
    },
    // 分享
    share() {
      this.showShare = true;
      this.getShareLink();
    },
    getShareLink() {
      let success = (data) => {
        const webShare = `${location.origin}/home/albumSharePage?album_sign=${this.videoSign}&id=${this.$route.query.id}&share=${data.data}&SharePage=true`;
        const h5Share = `${location.origin}/wap/pages/album/album-share?album_sign=${this.videoSign}&id=${this.$route.query.id}&share=${data.data}&SharePage=true`;
        this.shareLink = this.changeCopy === 1 ? webShare : h5Share;
      };
      this.$ajax({
        url: "/appapi/login/shareH5Url",
        method: "get",
        data: {
          type: 3, // 模块类型：0：视频；1：资源；2：直播；3：专辑
          id: this.$route.query.id, // 资源id
        },
        func: {
          success: success,
        },
      });
    },
    // 复制分享地址
    copyShareLink() {
      let input = document.createElement("input");
      input.value = this.shareLink;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      this.showShare = false;
      this.$message.success(this.$t("global.copySuccess"));
    },
    //收藏：
    collectAlbum() {
      let _method;
      let success = (data) => {
        if (this.is_fav == 0 && data.code == 200) {
          this.$message.success(this.$t("global.collect1"));
        } else {
          this.$message.success(this.$t("global.collect0"));
        }
        this.getAlbum();
      };
      if (this.is_fav == 0) {
        this.$ajax({
          url: "api/favourite/favourite",
          method: "post",
          data: {
            res_id: this.albumId,
            user_id: this.user_login_id,
            origin: 3,
          },
          func: {
            success: success,
          },
        });
      } else {
        this.$ajax({
          url: "api/favourite/favourite",
          method: "delete",
          params: {
            res_id: this.albumId,
            user_id: this.user_login_id,
            origin: 3,
          },
          func: {
            success: success,
          },
        });
      }
    },

    // 课程目录/专辑介绍的tab切换：
    taggleTabs(num) {
      this.albumTab = num;
    },
    // 获取专辑数据：
    getAlbumList() {
      let success = (data) => {
        data.data.forEach((item) => {
          item.child.forEach((item1) => {
            item1.status = false;
          });
        });
        this.albumListData = data.data;
        console.log(this.albumListData);
      };
      this.$ajax({
        url: "api/albumcompany/getalbums_l",
        method: "get",
        params: {
          albumid: this.albumId,
        },
        func: {
          success: success,
        },
      });
    },
    // {{$t('global.download')}}：
    downloadFile(type, is_download, id, url) {
      if (url == "null") {
        url = "";
      }
      if (is_download == 0) {
        this.$message.warning(this.$t("homepage.canotDown"));
        return false;
      }
      switch (type) {
        case 0:
          window.location.href =
            this.BASE_URL + "/index/openclass/videodownload?id=" + id;
          break;
        case 1:
          window.location.href =
            this.BASE_URL + "/index/test/download_test?id=" + id;
          break;
        case 2:
          window.location.href =
            this.BASE_URL + "/index/resource/resourcedownload?id=" + id;
          break;
      }
    },
    /** {{$t('global.check')}}：
     * type(0：视频；1：试卷；2：资源)
     */
    checkResource(type, resId, _id) {
      // 资源点击次数
      this.clickCount(_id);

      let url = location.origin;
      switch (type) {
        case 0:
          url ="/home/openclassDetail?id=" +
            resId +
            "&album_id=" +
            this.albumId;
          this.turnVideoDetails(resId, url, 1);
          break;
        case 1:
          url ="/home/albumPaper?id=" + resId;
          window.open(url);
          break;
        case 2:
          url ="/home/resourceDetail?id=" + resId;
          this.turnVideoDetails(resId, url, 3);
          break;
      }
    },
    clickCount(_id) {
      const success = (res) => {};
      let fail = (res) => {
        console.log("未登录、操作失败");
      };
      let params = {
        alv_id: _id,
        user_id: this.$g.user_id,
      };
      this.$ajax.post("api/album/album_user_count", params, {
        func: { success, fail },
      });
    },
    turnVideoDetails(id, url, type) {
      let success = (res) => {
        if (res.data.islimit == 0) {
          this.$message.closeAll()
          this.$message.warning(this.$t("global.authorityMessage"));
        } else {
          // window.open(url);
          this.$router.push(url);
        }
      };
      this.$ajax.get("/api/video/get_islimit_by_video_user_id", {
        params: {
          type: type,
          type_id: id,
          user_id: JSON.parse(sessionStorage.getItem("user_info_str"))
            ? JSON.parse(sessionStorage.getItem("user_info_str")).id
            : "",
        },
        func: { success },
      });
    },
    // 专辑介绍：
    // getAlbumIntroduct() {
    //   let success = data => {
    //     this.albumIntroductData = data.data[0]
    //     this.is_relation = data.data[0].is_relation

    //     if (this.albumIntroductData.avatar_path.includes('/static/default/user_preview-1.png') || this.albumIntroductData.avatar_path.includes('/public/picture')) {
    //       this.albumIntroductData.avatar_path = this.BASE_URL + this.albumIntroductData.avatar_path
    //     }

    //   }
    //   this.$ajax({
    //     url: "api/user/user",
    //     method: "get",
    //     params: {
    //       id: this.create_id,
    //       userid: this.user_login_id
    //     },
    //     func: {
    //       success: success
    //     }
    //   })
    // },

    // common公用组件里面的chat.vue,发私信：
    parent(obj) {
      this.$refs.child.getUserChatOne(obj);
    },
  },
  components: {
    // vueEmoji,
    // chat
  },
};
</script>
<style lang="scss" scoped>
.video-content {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #efefef;
  line-height: 48px;
  height: 48px;
  .video-title {
    line-height: 48px;
    height: 48px;
    text-indent: 6rem;
    width: 100%;
  }
  &:hover {
    .album_btns {
      display: block;
      width: 180px;
    }
    .video_type {
      display: none;
    }
  }
  .album_btns {
    display: none;
  }
  .video_type {
    width: 3rem;
  }
}

.section-title {
  text-indent: 4rem;
  cursor: pointer;
  width: 100%;
  line-height: 48px;
  height: 48px;
  border-bottom: 1px solid #efefef;
}
</style>
<style lang="scss">
.share_text {
  font-size: 16px;
  line-height: 25px;
  word-break: keep-all;

  .el-radio-group {
    margin: 20px 0 15px 0;
  }

  .el-radio__label {
    font-size: 15px;
  }
}

.album-nav-link {
  padding: 24px 0;
  font-size: 16px;

  a {
    color: #333;
  }

  i {
    margin: 0 6px;
  }

  strong {
    color: #999;
  }
}

.album-window {
  padding-bottom: 20px;

  .album-window-l {
    display: inline-block;
    width: 470px;
    height: 270px;
    background-color: #fff;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .album-window-r {
    display: inline-block;
    box-sizing: border-box;
    width: calc(100% - 490px);
    padding: 20px 30px 0;
    height: 270px;
    background-color: #fff;

    .albumb-w-h2 {
      font-size: 22px;
      font-weight: bold;
      line-height: 30px;
      height: 30px;
    }

    .keyword-tips {
      height: 30px;
      padding: 16px 0 22px;

      .el-tag {
        font-size: 14px;
        color: #3589b2;
        height: 30px;
        line-height: 30px;
        margin-right: 10px;
        background: #e1f3ff;
        border: 0 none;
      }
    }

    span {
      font-size: 14px;
    }

    .a-tit {
      // display: inline-block;
      // width: 80px;
      // margin-right: 10px;
    }

    .albumb-class,
    .albumb-study-count {
      padding: 8px 0;
      overflow: hidden;

      > div {
        border-left: 1px solid #d8d8d8;
        width: 100px;
        height: 40px;
        text-align: center;

        > span {
          display: block;
          color: #000;

          &:first-child {
            transform: translateY(-8px);
            height: 26px;
            line-height: 26px;
            font-size: 24px;
            word-spacing: 0.18px;
          }

          &:last-child {
            line-height: 20px;
            font-size: 14px;
            color: #666666;
            word-spacing: 0.11px;
          }
        }
      }
    }

    .albumb-study-count > div {
      border-right: 1px solid #d8d8d8;
    }

    .video-count {
      color: #db9c00;
    }

    .albumb-collect {
      height: 40px;
      line-height: 40px;

      .ipng {
        width: 25px;
        height: 40px;
        cursor: pointer;
      }

      .collect {
        background-position: -465px -768px;
      }

      .uncollect {
        background-position: -440px -768px;
      }
    }

    .albumb-share {
      margin-top: 40px;
      height: 20px;
      line-height: 20px;

      .a-tit {
        margin-right: 40px;
      }

      .share_ele {
        > div {
          line-height: 20px;

          > a {
            margin: 0;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}

.album-introduction {
  background-color: #fff;
  margin-bottom: 40px;

  .album-nav-tabs {
    border-bottom: 1px solid #efefef;

    // box-shadow: 0 2px 4px 0 rgba(195, 195, 195, 0.3);
    .is-active {
      color: #0057a7;
      position: relative;
      border-left: 1px solid #dddddd;
      border-right: 1px solid #dddddd;
    }

    .is-active::after {
      position: absolute;
      // top: 0;
      bottom: -2px;
      left: 0;
      //   right: -20px;
      content: "";
      width: 100%;
      height: 5px;
      background: #fff;
      //   border-bottom: 40px solid #edf5ff;
      //   border-top: 0 none;
      //   border-left: 0px solid transparent;
      //   border-right: 20px solid transparent;
    }

    .nav-tab {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 14px;
      cursor: pointer;

      &:first-child {
        border-left: 0 none;
      }
    }
  }

  .tab-pane {
    min-height: 300px;
    padding: 40px 40px 20px 45px;
  }

  .album-ul {
    .album-tit {
      font-size: 14px;
      line-height: 48px;
      height: 48px;
      background: #d6e4f2;
      // color: #3e6099;
      border-bottom: 1px solid #efefef;
    }

    .tit-num {
      display: inline-block;
      width: 100px;
      text-align: center;
    }

    .album-ls2 {
      font-size: 14px;
      .ls-content {
        position: relative;

        .profile {
          display: inline-block;
          vertical-align: top;
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        i {
          margin-right: 5px;
        }

        .album_btns {
          display: none;
          position: absolute;
          top: 0;
          right: 0;

          .el-button {
            width: 66px;
            height: 32px;
            padding: 0;
            font-size: 14px;
            background: #E62126;
            border: 0 none;
          }
        }
      }
    }

    .ls-content:hover > .album_btns {
      display: block;
    }

    .ls-content:hover > i {
      display: none;
    }

    .ls-content:hover > .album-ls2 {
      background-color: #effaff;
    }
  }

  .albumIntroduction {
    border-bottom: 1px dashed #e0e0e0;
    padding-bottom: 25px;
    margin-bottom: 30px;

    .avatar-path {
      display: block;
      float: left;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      cursor: auto;

      // box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
      img {
        width: 100%;
        height: 100%;
      }
    }

    .albumIntroduction-r {
      margin-left: 100px;

      .about-teacher {
        display: inline-block;
        width: 100%;
        // height: 30px;
        line-height: 80px;
        font-size: 22px;
      }

      .teacher-info {
        a {
          display: inline-block;
          line-height: 30px;
          font-size: 22px;
          // color: #2f6d8c;
          font-weight: bold;
          vertical-align: middle;
          cursor: auto;
        }

        strong {
          display: inline-block;
          padding: 0 15px;
          font-size: 14px;
          line-height: 30px;
          border-radius: 30px;
          color: #ffffff;
          background: #338efc;
          // padding: 7px 15px;
          margin-left: 15px;
          vertical-align: middle;
        }
      }

      .introduction-try {
        i {
          text-align: center;
          line-height: 40px;
          color: #ffffff;
          text-indent: 25px;
          margin-left: 40px;
          cursor: pointer;
        }

        .focus {
          background-position: -381px -473px;
          width: 100px;
          height: 40px;
        }

        .alfocus {
          background-position: -271px -473px;
          width: 100px;
          height: 40px;
        }
      }

      .other-infos {
        // padding-top: 20px;
        // span {
        //   font-size: 14px;
        //   color: #db9c00;
        //   margin-right: 40px;
        // }
        margin-top: 14px;

        > li {
          display: inline-block;
          padding: 9px 0;

          > div {
            width: 100px;
            height: 30px;
            text-align: center;
            border-left: 1px solid #dddddd;
            border-right: 1px solid #dddddd;

            > i {
              display: block;
              height: 24px;
              line-height: 24px;
              font-size: 18px;
              transform: translateY(-10px);
            }

            > span {
              line-height: 16px;
              font-size: 12px;
              color: #666666;
            }
          }

          &:last-child > div {
            border-left: 0 none;
          }
        }
      }
    }
  }

  .album-profile {
    font-size: 14px;
    line-height: 20px;

    .content {
      max-width: 1115px;
      text-indent: 2rem; // 首行缩进
      word-wrap: break-word; // 超长换行
    }
  }

  .album-outline,
  .album-appraise {
    .downBtn {
      margin-bottom: 20px;
    }
  }

  .empty-bgc-img {
    display: inline-block;
    width: 100%;
    height: 500px;
    background-image: url("../../../../../public/images/image08.png");
    background-size: 100%;
    position: relative;

    .i_resourceMask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
      text-align: center;
      visibility: hidden;
      opacity: 0;
      -moz-transition: all 0.35s ease-in;
      -webkit-transition: all 0.35s ease-in;
      -o-transition: all 0.35s ease-in;
      transition: all 0.35s ease-in;
    }

    &:hover .i_resourceMask {
      visibility: visible;
      opacity: 1;
    }

    span {
      font-size: 24px;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.1);
      border-radius: 15px;
      height: 70px;
      line-height: 70px;
      display: block;
      width: 370px;
      text-align: center;
      position: absolute;
      top: 45%;
      left: 50%;
      margin-left: -170px;
    }
  }
}

/* ----------emoji start */
.emoji {
  width: 380px;
  height: 186px;
  bottom: 30px;
  background: #fff;
  z-index: 10;
  padding: 10px;
  margin-right: 10px;
}

.emoji .emoji-controller {
  height: 36px;
  overflow: hidden;
  margin-bottom: 0;
}

.emoji .emoji-controller li {
  float: left;
  width: 76px;
  font-size: 12px;
  line-height: 36px;
  cursor: pointer;
  text-align: center;
  position: relative;
  text-align-last: initial;
}

.emoji .emoji-controller li.active::after {
  content: "";
  width: 100%;
  height: 1px;
  background: #0689dd;
  left: 0;
  bottom: 4px;
  position: absolute;
}

.emoji .emoji-container {
  height: 140px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.emoji .emoji-container li {
  font-size: 0;
  padding: 5px;
}

.emoji .emoji-container li a {
  float: left;
  overflow: hidden;
  height: 35px;
  transition: all ease-out 0.2s;
  border-radius: 4px;
}

.emoji .emoji-container li a:hover {
  background-color: #d8d8d8;
  border-color: #d8d8d8;
}

.emoji .emoji-container li a span {
  width: 25px;
  height: 25px;
  display: inline-block;
  border: 1px solid transparent;
  cursor: pointer;
}

.vueEmoji {
  position: absolute;
  right: 112px;
  bottom: 74px;
  margin: 0;
  box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
}

/* ----------emoji end */
</style>
